import React from 'react';

export default function CustomTitle(data) {
    return (
        <div className="disclaimer-title">{data.title}</div>
    );
}


// WEBPACK FOOTER //
// ./App/containers/layout/customTitle.jsx